module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stepOne"
  }, [(_vm.spinShow) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('headers'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('steps', {
    attrs: {
      "step-num": 0
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "stepOne-form"
  }, [_c('Form', {
    ref: "formValidate",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 80
    }
  }, [_c('FormItem', {
    attrs: {
      "label-width": 0,
      "prop": "loginNo"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入学号/工号"
    },
    model: {
      value: (_vm.formValidate.loginNo),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "loginNo", $$v)
      },
      expression: "formValidate.loginNo"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 0,
      "prop": "loginName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formValidate.loginName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "loginName", $$v)
      },
      expression: "formValidate.loginName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 0,
      "prop": "city"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择证件类型"
    },
    model: {
      value: (_vm.formValidate.idType),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "idType", $$v)
      },
      expression: "formValidate.idType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("居民身份证")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("护照")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("港澳台居民身份证")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("旅行证据")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("其他")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 0,
      "prop": "idNo"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入证件号"
    },
    model: {
      value: (_vm.formValidate.idNo),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "idNo", $$v)
      },
      expression: "formValidate.idNo"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 0,
      "prop": "code"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入图片中的字符，不限大小写"
    },
    model: {
      value: (_vm.formValidate.code),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "code", $$v)
      },
      expression: "formValidate.code"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.refreshCode
    }
  }, [_c('Sidentify', {
    attrs: {
      "identifyCode": _vm.identifyCode
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 0
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formValidate')
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dccd5922!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pc/stepOne.vue
// module id = 204
// module chunks = 0